interface LogoProps {
  variant?: 'default' | 'small';
  className?: string;
}

export function Logo({ variant = 'default', className }: LogoProps) {
  const isSmall = variant === 'small';

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/images/logo.png"
        alt="vibemarketing.diy"
        width={isSmall ? 150 : 200}
        height={isSmall ? 30 : 40}
        className="h-auto"
      />
    </div>
  );
}